import React, { useState, useEffect } from "react";
import LayoutV2 from "containers/LayoutV2";
import { Headersubfull } from "components/GenericComponent/HeaderSubFull/headersubfull";
import { SearchDesktopXuatHoaDon } from "./SearchDesktopXuatHoaDon";
import { SearchBarMobileXuatHoaDon } from "./SearchBarMobileXuatHoaDon";
import { TableDanhSachXuatHoaDon } from "./TableDanhSach";
import StoreApi from "../../../service/phanQuyenApi";
import UserApi from "service/userApi";

const initialDataSearch = {
  tuNgay: "01/01/2001",
  denNgay: "01/01/4000",
  ten: "",
  nhanvien: "",
  kieuvay: 0,
  loaithuchi: 55,
  tinhtrangno: -1,
  kenhthanhtoan: -1,
  trangThaiHoaDon: -2,
  pageIndex: 1,
  pageSize: 25,
};

const XuatHoaDon = () => {
  const initPhanQuyen = {
    thuchihopdong: false,
    thuchihopdong_dadoc: false,
    thuchihopdong_indanhsachphieuthuchihopdong: false,
    thuchihopdong_inphieuchi: false,
    thuchihopdong_inphieuthu: false,
    thuchihopdong_suaphieuthuchi: false,
    thuchihopdong_xoaphieuthuchi: false,
    thuchihopdong_hoahongtragop: false,
    SuDungPhiPhat_DongLai_TatToan: false,
    SuDungPhiPhat_DongLai_Cham: false,
    SuDungTatToanSom: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  const [quyenXuatHoaDon, setQuyenXuatHoaDon] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [dataSearch, setDataSearch] = useState(initialDataSearch);
  const [reloadKey, setReloadKey] = useState(0);

  const LoadPhanQuyen = () => {
    StoreApi.phanQuyenThuChiHopDong().then((response) => {
      setPhanQuyen((prevState) => ({
        ...prevState,
        thuchihopdong: response.data.thuchihopdong,
        thuchihopdong_dadoc: response.data.thuchihopdong_dadoc,
        thuchihopdong_indanhsachphieuthuchihopdong:
          response.data.thuchihopdong_indanhsachphieuthuchihopdong,
        thuchihopdong_inphieuchi: response.data.thuchihopdong_inphieuchi,
        thuchihopdong_inphieuthu: response.data.thuchihopdong_inphieuthu,
        thuchihopdong_suaphieuthuchi:
          response.data.thuchihopdong_suaphieuthuchihopdong,
        thuchihopdong_xoaphieuthuchi:
          response.data.thuchihopdong_xoaphieuthuchi,
        thuchihopdong_hoahongtragop: response.data.thuchihopdong_hoahongtragop,
        SuDungPhiPhat_DongLai_TatToan:
          response.data.SuDungPhiPhat_DongLai_TatToan,
        SuDungPhiPhat_DongLai_Cham: response.data.SuDungPhiPhat_DongLai_Cham,
        SuDungTatToanSom: response.data.SuDungTatToanSom,
      }));
    });
  };

  const LoadQuyenXuatHoaDon = () => {
    UserApi.getAllQuyen()
      .then((response) => {
        setQuyenXuatHoaDon(
          response.status === 200 &&
            Array.isArray(response.data) &&
            response.data.some(
              (e) => (e.ModuleCode || "").toLowerCase() === "xuathoadon",
            ),
        );
      })
      .catch(() => setQuyenXuatHoaDon(false));
  };

  const onSearchFieldChange = (field, value) => {
    setDataSearch((prev) => ({ ...prev, [field]: value }));
  };

  const onSearch = () => {
    setDataSearch((prev) => ({ ...prev, pageIndex: 1 }));
    setReloadKey((k) => k + 1);
  };

  const onPageChange = (page) => {
    setDataSearch((prev) => ({ ...prev, pageIndex: page }));
    setReloadKey((k) => k + 1);
  };

  const onPageSizeChange = (pageSize) => {
    setDataSearch((prev) => ({ ...prev, pageSize, pageIndex: 1 }));
    setReloadKey((k) => k + 1);
  };

  useEffect(() => {
    document.title = "Xuất hóa đơn | Phần mềm quản lý cầm đồ Morman";
    LoadQuyenXuatHoaDon();
    LoadPhanQuyen();
  }, []);

  return (
    <LayoutV2>
      {quyenXuatHoaDon === true && (
        <div id="form-repeater">
          <div className="sticky-moman-bh" style={{ paddingBottom: "0px" }}>
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div className="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/icon-logo-quan-ly-thu-chi.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Xuất hóa đơn</h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-3 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchDesktopXuatHoaDon
                      dataSearch={dataSearch}
                      onChange={onSearchFieldChange}
                      onSearch={onSearch}
                      isHoaHongTraGop={phanQuyen.thuchihopdong_hoahongtragop}
                    />
                  </div>
                </div>
                <SearchBarMobileXuatHoaDon
                  dataSearch={dataSearch}
                  onChange={onSearchFieldChange}
                  onSearch={onSearch}
                  isHoaHongTraGop={phanQuyen.thuchihopdong_hoahongtragop}
                />
              </div>
            </div>
          </div>
          <TableDanhSachXuatHoaDon
            dataSearch={dataSearch}
            reloadKey={reloadKey}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            daDoc={phanQuyen.thuchihopdong_dadoc}
            inPhieuChi={phanQuyen.thuchihopdong_inphieuchi}
            inPhieuThu={phanQuyen.thuchihopdong_inphieuthu}
            suaPhieu={phanQuyen.thuchihopdong_suaphieuthuchi}
            xoaPhieu={phanQuyen.thuchihopdong_xoaphieuthuchi}
            isHoaHongTraGop={phanQuyen.thuchihopdong_hoahongtragop}
            isSuDungPhiPhatDongLaiCham={phanQuyen.SuDungPhiPhat_DongLai_Cham}
            isDuDungPhiPhatDongLaiTatToan={
              phanQuyen.SuDungPhiPhat_DongLai_TatToan
            }
            SuDungTatToanSom={phanQuyen.SuDungTatToanSom}
            showStatus={true}
            showActions={false}
            enableSelection={true}
            selectedIds={selectedIds}
            onSelectedIdsChange={setSelectedIds}
          />
        </div>
      )}
      {quyenXuatHoaDon === false && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <Headersubfull
                      title="Xuất hóa đơn"
                      icon1="fas fa-file-invoice"
                    />
                    <div className="col-sm-12 col-md-3 d-flex just-end hidden-mobile-main"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};

export default XuatHoaDon;
